import { Component, OnInit, ViewEncapsulation, Output, Input } from '@angular/core';
import { RatePackageEventType } from './../rate-package.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { RatePackageService } from './../rate-package.service';
import { MatTableDataSource } from '@angular/material/table';
import { Pacote } from '../models/pacote.model';
import { TweenMax, Quint } from 'gsap';
import { Util } from '../../../utils/util';
import { MatDialog } from '@angular/material';
import { OthersPackagesModalComponent } from './others-packages-modal/others-packages-modal.component';

@Component({
	selector: 'app-others-packages',
	templateUrl: './others-packages.component.html',
	styleUrls: ['./others-packages.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class OthersPackagesComponent implements OnInit {

	public otherPackages: Pacote[] = [];
	public active: Boolean = false;
	private view = '[data-component="others-packages"]';
	public displayedColumns: Array<string> = ['service', 'amount'];
	public haventRegisters = true;

	constructor(private ratePackageService: RatePackageService, public dialog: MatDialog) { }

	ngOnInit() {
		AppEventDispatcher.listen(RatePackageEventType.STEPS.OTHERS, data => {
			if (data.show) {
				this.show();
			} else {
				this.hide();
			}
		});
	}

	show() {
		this.getOtherPackages();
	}

	getOtherPackages() {
		this.preload(true);
		this.active = true;

		this.ratePackageService.getOthersPackages().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.otherPackages = Util.keysToCamel(data.Retorno) as Pacote[];
			}
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro, tente novamente mais tarde.' });
			this.preload(false);
		});
	}

	hide() {
		this.active = false;
	}

	sendForm(item) {
		this.preload(true);
		AppEventDispatcher.dispatch(RatePackageEventType.HIRE_PACKAGE, { show: true, pacote: item });

		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(RatePackageEventType.STEPS.CONFIRM, {show: true});

			TweenMax.to(this.view, 0.8, {
				delay: 0.1,
				left: '-100%',
				ease: Quint.easeOut,
				onComplete: () => {
					this.active = false;
				}
			});
		});

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="rate-packege"] .content',
			show: active,
			delay: delay
		});
	}

	openModal(pacote: Pacote): void {
		this.dialog.open(OthersPackagesModalComponent, {
			width: '550px',
			data: { package: pacote }
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/others-packages/others-packages.component.ts